import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule, MatButtonAppearance } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MatIcon, MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'app-button',
  imports: [MatButtonModule, MatTooltipModule, RouterModule, MatIconModule],
  templateUrl: './button.html',
  styleUrl: './button.scss',
  standalone:true
})
export class Button {
  @Input() text: string = '';
  @Input() isDisabled:boolean = false;
  @Input() tooltip:string = '';
  @Input() href:string = '';
  @Input() isLink:boolean = false;
  @Input() type:string = '';
  @Input() typeButton:string = 'button | icon';
  @Input() matButtonAparence: MatButtonAppearance = 'filled';
  @Input() matButtonExtension: string = 'fab | icon';
  @Input() color: string = '';

  @Output() onSubmit = new EventEmitter();

  submit=(event:Event) =>{
    this.onSubmit.emit(event);
  }
}
